<h1 mat-dialog-title>Confirmación</h1>
<div mat-dialog-content>
    <p style="white-space: pre-line;" [innerHtml]="mensaje"></p>
</div>
<div mat-dialog-actions class="justify-content-center">
    <button mat-raised-button color="warn" (click)="cerrarDialogo()">No</button>
    <button mat-raised-button color="primary" (click)="confirmado()">Si</button>
</div>